import { FC } from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

interface LoadingProps {
  type: 'Audio' | 'Bars' | 'Watch';
  color: string;
  text: string;
}

const Loading: FC<LoadingProps> = ({ type, color, text }) => {
  return (
    <div
      style={{
        color: '#fff',
        width: `${100}%`,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader
        type={type}
        color={color}
        height={100}
        width={100}
        timeout={3000} //3 secs
      />
      <h1>{text}</h1>
    </div>
  );
};

export default Loading;
